<script>
import meetups from "./Meetups/meetups-store";
import Header from "./UI/Header.svelte";
import MeetupGrid from "./Meetups/MeetupGrid.svelte";
// import Button from "./UI/Button.svelte";
import EditMeetup from "./Meetups/EditMeetup.svelte";
import MeetupDetail from "./Meetups/MeetupDetail.svelte";
import LoadingSpiner from "./UI/LoadingSpiner.svelte";
import Error from './UI/Error.svelte';


let loadedMeetups = meetups;

// let meetups = ;

let editMode;
let editedId;
let page ='overview'
let pageData ={};
let isLoading = true;
let error;
fetch('https://meetups-c7487-default-rtdb.firebaseio.com/meetups.json')
.then(res => {
  if (!res.ok){
    throw new Error('try again later')
  }
  return res.json();
})
.then(data => {
  const loadedMeetupss = [];
  for ( const key in data){
    loadedMeetupss.push({
      ...data[key],
      id: key
    });
  }
  setTimeout(() =>{
    isLoading = false;
    loadedMeetups.setMeetups(loadedMeetupss.reverse());
  },1000)
  
})
.catch(err =>{
  error = err;
  isLoading = false;
  console.log(err);
})

function cancelEdit(){
  editMode = null;
  editedId = null;
}
function savedMeetup(event){
  editMode = null;
  editedId = null;
};
function showDetails(event){
  page = 'details';
  pageData.id =event.detail;
}
function closeDetail(){
  page = 'overview';
  pageData ={};
}
function startEdit(event){
  editMode = 'edit';
  editedId = event.detail;
}
function errorCancel(){
  error=null;
}
</script>


<style>

	main{
        margin-top: 5rem;
    }
 
</style>

{#if error}
  <Error message="{error.message}"on:cancel={errorCancel}/>
{/if}
<Header/>
<main>
  {#if page === 'overview'}
  
      {#if editMode === 'edit'}
        <EditMeetup 
        id={editedId} 
        on:save="{savedMeetup}" 
        on:cancel ={cancelEdit}
        />
      {/if}
      
      {#if isLoading}
     
        <LoadingSpiner/>   
      {:else}
        <MeetupGrid 
        meetups={$loadedMeetups} 
        on:showdetails={showDetails} 
        on:edit ={startEdit}
        on:add ={() => {editMode = 'edit'}}
        />
      {/if}
    
  {:else}
    <MeetupDetail id= {pageData.id} on:close={closeDetail}/>
  {/if}

</main>



